<template>
    <div>
        <Header> </Header>
        <Row>
            <img src="@/assets/mobile/about/pos1-bg.jpg" />
        </Row>
        <Row className="pos2">
            <img class="tit" src="@/assets/mobile/about/pos2-tit.png" />
            <p>
                浙文互联成立于1993年，于2004年在上海证券交易所上市，股票代码（600986.SH），自2020年12月浙江省文化产业投资集团有限公司为代表的新股东加入，公司名称变更为浙文互联。<br />
                浙文互联以技术、数据和内容创新为驱动力，以客户需求为中心，致力于为品牌提供智能营销解决方案。面对数字营销行业的新趋势，集团率先拓展影视IP打造、视频内容整合、电竞娱乐、直播电商等领域，打破营销次元，布局元宇宙虚拟资产，推动数字营销与文创产业相互融合与促进，创引产业新未来，助力谱写数字中国新篇章。<br />
                公司业务领域包括数字营销、品牌管理与传播、公关传播、智能营销、社群营销、事件营销、汽车直播运营、直播与短视频平台等全链路整合数字营销体系，拥有智魔方数据中台，通过研发DMP大数据管理平台、搭建云及IDC基础架构、业务及数据PaaS平台等，助力内部快速实现数据整合、分析、处理及共享，有效为汽车、电商、游戏、金融、旅游、快速消费品等行业客户提供兼具影响力和效果一体化的数字营销解决方案。<br />
                浙文互联旗下拥有派瑞威行（ASPIRATION）、百孚思（iFORCE）、爱创（itrax）、同立传播（UNI GROUP）、华邑（Target-uni）、雨林木风（YLMF）、智阅网络、杭州浙文科技等子品牌，员工规模超1000人。
            </p>
        </Row>
        <div class="pos3">
            <div class="tab">
                <div class="item" :class="honorTabIdx == 1 ? 'active' : ''" @click="HonorTabHandle(1)">
                    <div>行业地位</div>
                    <span></span>
                </div>
                <div class="item" :class="honorTabIdx == 2 ? 'active' : ''" @click="HonorTabHandle(2)">
                    <div>荣誉奖项</div>
                    <span></span>
                </div>
            </div>
            <ul v-if="honorTabIdx == 1" class="standing">
                <li v-for="item in standing" :key="item.id">
                    <img :src="resourceBaseUrl + item.cover + '?x-oss-process=image/resize,m_fill,w_300,h_250'" />
                </li>
            </ul>
            <ul v-if="honorTabIdx == 2" class="honor">
                <li v-for="item in honor" :key="item.id">
                    <img :src="resourceBaseUrl + item.cover + '?x-oss-process=image/resize,m_fill,w_300,h_300'" />
                </li>
            </ul>
        </div>
        <Row bg="assets/mobile/about/pos4-bg.jpg" className="pos4">
            <ul>
                <li>
                    <div>
                        <div>
                            <a target="_blank" href="http://www.aspiration-cn.com"><img src="@/assets/mobile/home/brand/pairui.jpg"/></a>
                        </div>
                    </div>
                </li>
                <li>
                    <div>
                        <div>
                            <a target="_blank" href="http://www.iforce-media.com/"><img src="@/assets/mobile/home/brand/iforce.jpg"/></a>
                        </div>
                    </div>
                </li>
                <li>
                    <div>
                        <div>
                            <a target="_blank" href="http://www.itrax.cn"><img src="@/assets/mobile/home/brand/itrax.jpg"/></a>
                        </div>
                    </div>
                </li>
                <li>
                    <div>
                        <div>
                            <router-link to="/m/about/tongli"><img src="@/assets/mobile/home/brand/tongli.jpg"/></router-link>
                        </div>
                    </div>
                </li>
                <li>
                    <div>
                        <div>
                            <router-link to="/m/about/huayi"><img src="@/assets/mobile/home/brand/huayi.jpg"/></router-link>
                        </div>
                    </div>
                </li>
                <li>
                    <div>
                        <div>
                            <router-link to="/m/about/ylmf"><img src="@/assets/mobile/home/brand/ylmf.jpg"/></router-link>
                        </div>
                    </div>
                </li>
                <li>
                    <div>
                        <div>
                            <a target="_blank" href="https://www.qctt.cn"><img src="@/assets/mobile/home/brand/qctt.jpg"/></a>
                        </div>
                    </div>
                </li>
                <li>
                    <div>
                        <div>
                            <router-link to="/m/about/hzzw"><img src="@/assets/mobile/home/brand/hzzw.jpg"/></router-link>
                        </div>
                    </div>
                </li>
            </ul>
        </Row>
        <Row className="pos5">
            <img src="@/assets/mobile/about/pos5-tit.png" class="tit" />
            <ul class="tab">
                <li :class="pos5TabIdx == 1 ? 'active' : ''" @click="Pos5TabHandle(1)">
                    <div>汽车行业</div>
                    <span class="iconfont icon-triangle"></span>
                </li>
                <li :class="pos5TabIdx == 2 ? 'active' : ''" @click="Pos5TabHandle(2)">
                    <div>快消及金融行业</div>
                    <span class="iconfont icon-triangle"></span>
                </li>
                <li :class="pos5TabIdx == 3 ? 'active' : ''" @click="Pos5TabHandle(3)">
                    <div>互联网IT及电商</div>
                    <span class="iconfont icon-triangle"></span>
                </li>
                <li :class="pos5TabIdx == 4 ? 'active' : ''" @click="Pos5TabHandle(4)">
                    <div>休闲娱乐</div>
                    <span class="iconfont icon-triangle"></span>
                </li>
            </ul>
            <div class="detail" v-if="customer">
                <img v-show="pos5TabIdx == 1" :src="resourceBaseUrl + customer.mobileAuto" />
                <img v-show="pos5TabIdx == 2" :src="resourceBaseUrl + customer.mobileFmcg" />
                <img v-show="pos5TabIdx == 3" :src="resourceBaseUrl + customer.mobileIt" />
                <img v-show="pos5TabIdx == 4" :src="resourceBaseUrl + customer.mobileAmusement" />
            </div>
        </Row>

        <Row className="pos6" v-if="false">
            <div class="wrap">
                <img src="@/assets/mobile/about/pos6-tit.png" class="tit" />
                <div class="swiper">
                    <carousel-3d :perspective="0" :autoplayHoverPause="true" :width="clientWidth * 0.4" :data-w="clientWidth * 0.4" :height="(clientWidth * 0.4 * 421) / 296" :data-h="(clientWidth * 0.4 * 421) / 296" :space="clientWidth * 0.45" :border="0" :display="3" :controlsVisible="true" controlsNextHtml="" controlsPrevHtml="" @after-slide-change="onSlideChange">
                        <slide :index="idx" v-for="(item, idx) in leader" :key="idx">
                            <template slot-scope="{ index, isCurrent, leftIndex, rightIndex }">
                                <div class="swiper-item">
                                    <img :data-index="index" :class="{ current: isCurrent, onLeft: leftIndex >= 0, onRight: rightIndex >= 0 }" :src="require('@/assets/mobile/about/leader/' + (idx + 1) + '.jpg')" />
                                </div>
                            </template>
                        </slide>
                    </carousel-3d>
                    <h5>{{ leader[leaderSwiperIdx].name }}</h5>
                    <p v-html="leader[leaderSwiperIdx].desc"></p>
                </div>
                <ul class="pager">
                    <li v-for="(item, idx) in leader" :key="idx" :class="idx == leaderSwiperIdx ? 'active' : ''"></li>
                </ul>
            </div>
        </Row>

        <Footer></Footer>
    </div>
</template>
<script>
import Header from "../../components/mobile/header.vue";
import Footer from "../../components/mobile/footer.vue";
import Row from "../../components/mobile/Row.vue";
// import MoreBtn from "../../components/mobile/MoreBtn.vue";
import settings from "@/settings";
import { Carousel3d, Slide } from "vue-carousel-3d";
export default {
    name: "mobile-about",
    components: { Header, Footer, Row, Carousel3d, Slide },
    data() {
        return {
            resourceBaseUrl: settings.resourceBaseUrl,
            standing: [],
            honor: [],
            honorTabIdx: 1,
            pos5TabIdx: 1,
            customer: null,
            clientWidth: document.body.clientWidth,
            leader: [
                {
                    name: "唐  颖",
                    desc: "浙文互联集团董事长兼CEO、<br>百孚思创始人",
                },
                {
                    name: "张  磊",
                    desc: "浙文互联集团总经理、<br> 百孚思CEO ",
                },
                {
                    name: "易  星",
                    desc: "浙文互联集团联席总经理、<br> 派瑞威行CEO",
                },
                {
                    name: "吴瑞敏",
                    desc: "浙文互联集团联席总经理、<br> 爱创营销与传播CEO",
                },
                {
                    name: "王颖轶",
                    desc: "浙文互联集团副经理、<br> 董事会秘书 ",
                },
                {
                    name: "李  磊",
                    desc: "浙文互联集团副总经理、 <br> 汽车业务部总经理",
                },
                {
                    name: "孟  娜",
                    desc: "浙文互联集团副总经理",
                },
            ],
            leaderSwiperIdx: 0,
        };
    },
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.loadHonor();
        this.LoadCustomer();
    },
    methods: {
        onSlideChange(e) {
            this.leaderSwiperIdx = e;
        },
        Pos5TabHandle(idx) {
            this.pos5TabIdx = idx;
        },
        HonorTabHandle(idx) {
            this.honorTabIdx = idx;
        },
        loadHonor() {
            this.$http.get("/api/honor/list").then((res) => {
                this.honor = res.data.filter((item) => item.type == 2);
                this.standing = res.data.filter((item) => item.type == 1);
            });
        },
        LoadCustomer() {
            this.$http.get("/api/customer/config").then((res) => {
                this.customer = res.data;
            });
        },
    },
};
</script>

<style scoped>
.pos6 .pager {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 40px;
}
.pos6 .pager li {
    width: 15px;
    height: 2px;
    background: #939393;
    margin: 0 3px;
    border-radius: 1px;
}
.pos6 .pager .active {
    background: #333333;
}
.pos6 .swiper {
    margin: 30px 15px 0 15px;
}
.pos6 h5 {
    font-size: 1.6rem;
    text-align: center;
    margin: 10px 0;
}
.pos6 p {
    text-align: center;
    font-size: 1.2rem;
    white-space: nowrap;
    margin-bottom: 30px;
}
.pos6 .tit {
    width: 64%;
    margin-top: 35px;
}
.pos6 .wrap {
    background: #f3f3f3;
    width: 100%;
}

.pos5 .detail {
    margin: 0 15px 30px 15px;
}
.pos5 .tit {
    width: 40%;
    margin: 40px auto 30px auto;
}
.pos5 .tab {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 15px 10px 15px;
}
.pos5 .tab li {
    font-size: 1.3rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.pos5 .tab li span {
    color: #f9b924;
    opacity: 0;
    margin-top: -5px;
    font-size: 0.6rem;
    line-height: 1.2rem;
}
.pos5 .tab li div {
    border-bottom: 2px #fff solid;
    padding-bottom: 3px;
    line-height: 1.7rem;
}
.pos5 .tab .active {
    color: #f9b924;
    font-weight: bold;
}
.pos5 .tab .active div {
    border-color: #f9b924;
}
.pos5 .tab .active span {
    opacity: 1;
}
.pos4 ul {
    margin: 31% 15px 0 15px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.pos4 ul li {
    width: 23%;
    background: #fff;
    display: inline-block;
    margin: 5px 0;
}
.pos4 ul li > div {
    width: 100%;
    padding-bottom: 100%;
    position: relative;
}
.pos4 ul li > div > div {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
}
.pos3 .honor,
.pos3 .standing {
    margin: 10px 15px 30px 15px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.pos3 .honor li {
    width: 22%;
    margin: 6px 0;
}
.pos3 .standing li {
    width: 48.5%;
    margin: 6px 0;
}
.pos3 .tab {
    margin: 140px 15px 20px 15px;
    display: block;
    border-bottom: 1px #a3c6ec solid;
}
.pos3 .tab .item {
    width: 50%;
    display: inline-flex;
    color: #fff;
    align-items: center;
    justify-content: center;
    position: relative;
}
.pos3 .tab .item div {
    width: 70%;
    border-bottom: 2px transparent solid;
    text-align: center;
    font-size: 1.5rem;
    padding: 5px 0;
}
.pos3 .tab .item span {
    position: absolute;
    left: 50%;
    bottom: -2px;
    width: 3px;
    height: 3px;
    background: #fff;
    transform: rotate(45deg);
    margin-left: -2px;
    display: none;
}

.pos3 .tab .active div {
    font-weight: bold;
    border-bottom: 2px #fff solid;
}
.pos3 .tab .active span {
    display: inline-block;
}
.pos3 {
    background-image: url("~@/assets/mobile/about/pos3-bg.jpg");
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 100% auto;
    background-color: #5485c4;
    min-height: 500px;
    display: inline-block;
    width: 100%;
}
.pos2 .tit {
    width: 50%;
    margin: 30px 0;
}
.pos2 p {
    margin: 0 25px 30px 25px;
    text-align: left;
    color: #838587;
    font-size: 1.2rem;
    line-height: 2rem;
}
</style>
